import { atomWithStorage } from 'jotai/utils';

export const userPrefsAtom = atomWithStorage('userPrefs', []);